import { WPImage, ThemeLink, ThemeLinkLogic } from "_types";

type TypeWithBoolean = {
  enable: boolean;
}

export enum EVENT_TAKEOVER_PRIMARY_COLOUR {
  WHITE = 'white',
  BLACK = 'black,'
}

export enum EVENT_TAKEOVER_BACKGROUND_TYPE {
  IMAGE = 'image',
  VIDEO = 'video',
}

export type EventTakeoverVisual = {
  background: {
    type: EVENT_TAKEOVER_BACKGROUND_TYPE;
    images?: WPImage[];
    images_mobile?: WPImage[];
    displacement?: WPImage;
    displacement_mobile?: WPImage;
    video?: WPImage;
  };
  sheet_effect: {
    enable: boolean;
    displacement: WPImage;
    displacement_mobile?: WPImage;
  }
}

export type EventTakeoverType = {
  primary_colour: EVENT_TAKEOVER_PRIMARY_COLOUR;
  buttons: {
    is_primary: boolean;
    link: ThemeLink;
  }[];
  visual: EventTakeoverVisual;
  text_keys: {
    title_preface: string;
    title: string;
    bottom_left_corner: string;
  }
} & TypeWithBoolean;

export type HomePageHeroSectionType = {
  enable_link?: boolean;
  images?: WPImage[];
  link_settings?: { link: ThemeLink };
  text?: {
    headline: {
      top_line: string;
      bottom_line: string;
    }
    body_text: string;
  }
} & TypeWithBoolean;

export type HomePageNextEventSectionType = {
  image: WPImage;
  text: {
    title: string;
    slider_text: string;
    date: string;
    text: string;
  };
  links: {
    link: ThemeLink;
    secondary_links: { link: ThemeLink }[];
  };
  enable_countdown: boolean;
  event_start: string;
} & TypeWithBoolean;

export type HomePageLatestSectionType = {
  title: string;
  enable_all_button: boolean;
  show_all_button_label: string;
} & TypeWithBoolean;

export type HomePageHeroAlternativeBlockType = {
  title: string;
  subtitle?: string;
  description?: string;
  image: WPImage;
  link: ThemeLink;
}

export type HomePageHeroAlternativeType = {
  blocks: HomePageHeroAlternativeBlockType[];
} & TypeWithBoolean;

export type HomePageWhatsComingBlockType = {
  title: string;
  date: string;
  enable_link: boolean;
  link: {
    link: ThemeLinkLogic;
  }
}

export type HomePageWhatsComingType = {
  title: string;
  blocks: HomePageWhatsComingBlockType[];
} & TypeWithBoolean;

export type HomePageCMS = {
  hero_alternative: HomePageHeroAlternativeType;
  event_takeover: EventTakeoverType;
  hero_section: HomePageHeroSectionType;
  whats_coming: HomePageWhatsComingType;
  next_event_section: HomePageNextEventSectionType;
  latest_section: HomePageLatestSectionType;
};